import BookItem from "@app/components/book-item";
import Pagination from "@app/components/pagination";
import SkeletonGrid from "@app/components/skeleton-grid";
import { DEFAULT_PAGE, DEFAULT_REQUEST_PARAMS } from "@app/constants";
import BookService from "@app/services/http/book.service";
import { Book, Meta } from "@app/types";
import { Images } from "@assets/images";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { RequestParams } from "@core/services/http/http.type";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function Search() {
  const [searchParams] = useSearchParams();
  const { abortController } = useCancellationRequest();

  const [books, setBooks] = useState<Book[]>([]);
  const [requestParams, setRequestParams] = useState<RequestParams>({
    ...DEFAULT_REQUEST_PARAMS,
    pageSize: 50,
  });
  const [meta, setMeta] = useState<Meta>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      keyword: searchParams.get("keyword")
        ? String(searchParams.get("keyword"))
        : "",
    };

    BookService.searchBooks(newRequestParams, abortController.signal)
      .then((res) => {
        setBooks(res.data.items);
        setMeta(res.data.meta);

        if (
          requestParams.pageNum &&
          res.data.meta.totalPage > 0 &&
          res.data.meta.totalPage < requestParams.pageNum
        ) {
          const newRequestParams: RequestParams = {
            ...requestParams,
            pageNum: DEFAULT_PAGE,
          };

          setRequestParams(newRequestParams);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams.get("keyword"), requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      pageNum: page,
    };

    setRequestParams(newRequestParams);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="px-[100px] min-h-[calc(100vh-328px)]">
      <div className="mt-[60px] flex items-center gap-4">
        <img
          className="bg-[#DFE2E7] p-3 rounded-xl"
          src={Images.SearchNormalIcon.default}
          alt=""
        />
        <div className="text-xl font-medium font-[SVN-Gilroy]">
          Kết quả tìm kiếm cho từ “{searchParams.get("keyword")}”
        </div>
      </div>
      {!loading && books.length ? (
        <div>
          <div className="mt-9 flex flex-wrap gap-6">
            {books.map((book) => (
              <div key={book.id}>
                <BookItem book={book} />
              </div>
            ))}
          </div>
          {meta && (
            <div className="flex justify-center mt-3">
              <Pagination
                currentPage={meta.pageNum}
                totalPages={meta.totalPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      ) : !loading ? (
        <div className="mt-[164px] flex flex-col items-center">
          <img
            className="w-[120px]"
            src={Images.ResultNotFound.default}
            alt=""
          />
          <div className="font-[SVN-Gilroy] font-semibold tracking-[0.024px] text-[#171A20]">
            Không tìm thấy kết quả nào cho
          </div>
          <div className="font-[SVN-Gilroy] font-medium tracking-[0.024px] text-[#4E586C]">
            “{searchParams.get("keyword")}”
          </div>
        </div>
      ) : (
        <div className="mt-9">
          <SkeletonGrid />
        </div>
      )}
    </div>
  );
}

export default Search;
